const maskCPF = (value) => {
  return value
    ?.replace(/\D/g, "")
    ?.replace(/(\d{3})(\d)/, "$1.$2")
    ?.replace(/(\d{3})(\d)/, "$1.$2")
    ?.replace(/(\d{3})(\d{1,2})/, "$1-$2")
    ?.replace(/(-\d{2})\d+?$/, "$1");
};
const removeMask = (value) => {
  return value?.replace(/\D/g, "");
};
const maskPhone = (value) => {
  return value
    ?.replace(/\D/g, "")
    ?.replace(/(\d{2})(\d)/, "($1) $2")
    ?.replace(/(\d{5})(\d)/, "$1-$2")
    ?.replace(/(-\d{4})(\d+?)$/, "$1");
};
const maskCellPhone = (value) => {
  return value
    ?.replace(/\D/g, "")
    ?.replace(/(\d{2})(\d)/, "($1) $2")
    ?.replace(/(\d{4})(\d)/, "$1-$2")
    ?.replace(/(-\d{4})(\d+?)$/, "$1");
};
const maskCnpj = (value) => {
  return value
    ?.replace(/\D/g, "")
    ?.replace(/(\d{2})(\d)/, "$1.$2")
    ?.replace(/(\d{3})(\d)/, "$1.$2")
    ?.replace(/(\d{3})(\d)/, "$1/$2")
    ?.replace(/(\d{4})(\d)/, "$1-$2")
    ?.replace(/(-\d{2})\d+?$/, "$1");
};
const isValidCPF = (cpf) => {
  if (
    typeof cpf !== "string" ||
    cpf.length !== 11 ||
    !Array.from(cpf).filter((e) => e !== cpf[0]).length
  ) {
    return false;
  }
  let soma = 0;
  let resto;
  for (let i = 1; i <= 9; i++)
    soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(9, 10))) return false;
  soma = 0;
  for (let i = 1; i <= 10; i++)
    soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(10, 11))) return false;
  return true;
};

export { maskCPF, removeMask, maskPhone, maskCellPhone, maskCnpj, isValidCPF };
